import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Flex, Image } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";
import { useLoadOnboarding } from "~/hooks/useLoadOnboarding";
import Conceive from "~/images/logos/conceive.svg";
import { Nav } from "~/OnboardingApp/features/Nav";
import { OnboardingRedirector } from "./OnboardingRedirector";

export const OnboardingLayout: FC = () => {
  const { hasLoadedInitial } = useLoadOnboarding();

  if (!hasLoadedInitial)
    return (
      <FullBleedSection bgColor="bg-main" h="100vh">
        <Image src={Conceive} maxW="20rem" mb="20rem" w="100%" />
      </FullBleedSection>
    );

  return (
    <OnboardingRedirector>
      <Flex align="center" direction="column" minH="100vh" w="100%">
        <Nav />
        <Flex align="center" as="main" direction="column" flexGrow={1} w="100%">
          <Outlet />
        </Flex>
      </Flex>
    </OnboardingRedirector>
  );
};
